export const FETCH_USER_AUTHORIZATION = 'FETCH_USER_AUTHORIZATION';
export const FETCH_USER_AUTHORIZATION_SUCCESS = 'FETCH_USER_AUTHORIZATION_SUCCESS';
export const FETCH_USER_AUTHORIZATION_FAILURE = 'FETCH_USER_AUTHORIZATION_FAILURE';